"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Editor = void 0;
var material_1 = require("@mui/material");
var DeleteForever_1 = __importDefault(require("@mui/icons-material/DeleteForever"));
var react_1 = __importStar(require("react"));
var ValueEditor_1 = require("./editors/ValueEditor");
var deleteChild_1 = __importDefault(require("../utils/deleteChild"));
var getChild_1 = __importDefault(require("../utils/getChild"));
var setChild_1 = __importDefault(require("../utils/setChild"));
var typeFromValue_1 = __importDefault(require("../utils/typeFromValue"));
var valueFromType_1 = __importDefault(require("../utils/valueFromType"));
var LevelSelector_1 = require("./LevelSelector");
var newArrayItemValue = function (subobj) {
    if (subobj.length > 0) {
        var lastItem = subobj[subobj.length - 1];
        return (0, valueFromType_1.default)((0, typeFromValue_1.default)(lastItem));
    }
    return '';
};
var newObjectItemValue = function (subobj) {
    var objKeys = Object.keys(subobj);
    if (objKeys.length > 0) {
        var lastItem = subobj[objKeys[objKeys.length - 1]];
        return (0, valueFromType_1.default)((0, typeFromValue_1.default)(lastItem));
    }
    return '';
};
var newObjectItemKey = function (subobj) {
    // create a new property name that uses the last property name with new number of the end
    var objKeys = Object.keys(subobj);
    var i = 1;
    var newKey = "item".concat(i);
    while (objKeys.includes(newKey)) {
        i += 1;
        newKey = "item".concat(i);
    }
    return newKey;
};
function Editor(_a) {
    var value = _a.value, onChange = _a.onChange;
    var _b = __read((0, react_1.useState)([]), 2), path = _b[0], setPath = _b[1];
    var _c = __read((0, react_1.useState)(value), 2), obj = _c[0], setObj = _c[1];
    var _d = __read((0, react_1.useState)(path[path.length - 1]), 2), propName = _d[0], setPropName = _d[1];
    (0, react_1.useEffect)(function () {
        setPropName(path[path.length - 1]);
    }, [path]);
    (0, react_1.useEffect)(function () {
        setObj(value);
    }, [value]);
    var setNewPropName = function () {
        var newPath = path.slice(0, path.length - 1);
        if (propName !== undefined) {
            newPath.push(propName);
        }
        var existingItem = (0, getChild_1.default)(obj, path);
        var newObj = (0, setChild_1.default)((0, deleteChild_1.default)(obj, path), newPath, existingItem);
        setObj(newObj);
        setPath(newPath);
        onChange(newObj);
    };
    var updateObj = (0, react_1.useCallback)(function (subobj) {
        var newObj = (0, setChild_1.default)(obj, path, subobj);
        setObj(newObj);
        onChange(newObj);
    }, [obj, path, onChange]);
    var deleteCurrent = function () {
        var newObj = (0, deleteChild_1.default)(obj, path);
        setObj(newObj);
        setPath(path.slice(0, path.length - 1));
        onChange(newObj);
    };
    return (react_1.default.createElement(material_1.Stack, { width: "100%", direction: "column", justifyContent: "flex-start", alignItems: "flex-start", spacing: 2 },
        react_1.default.createElement(LevelSelector_1.LevelSelector, { path: path, setPath: setPath, obj: obj }),
        react_1.default.createElement(material_1.Stack, { display: "flex", flex: "1", width: "100%", direction: "column", justifyContent: "flex-start", alignItems: "flex-start", spacing: 2 },
            react_1.default.createElement(material_1.Stack, { display: "flex", direction: "column", justifyContent: "flex-start", alignItems: "flex-start", width: "100%", flex: "1", spacing: 2 },
                typeof propName === 'string' ? (react_1.default.createElement(material_1.TextField, { size: "small", fullWidth: true, label: "Property Name", value: propName, InputLabelProps: { shrink: true }, onChange: function (e) { return setPropName(e.target.value); }, onBlur: setNewPropName })) : undefined,
                react_1.default.createElement(ValueEditor_1.ValueEditor, { newArrayItemValue: newArrayItemValue, newObjectItemValue: newObjectItemValue, newObjectItemKey: newObjectItemKey, value: (0, getChild_1.default)(obj, path), onEdit: function (index) { return setPath(__spreadArray(__spreadArray([], __read(path), false), [index], false)); }, onChange: updateObj })),
            path.length > 0 ? (react_1.default.createElement(material_1.Box, { width: "100%" },
                react_1.default.createElement(material_1.Button, { endIcon: react_1.default.createElement(DeleteForever_1.default, null), color: "error", variant: "outlined", fullWidth: true, onClick: deleteCurrent }, "Delete"))) : undefined)));
}
exports.Editor = Editor;
